import type { FunctionComponent } from 'react';

import { Skeleton } from '@/core/tamagoshi/Skeleton/Skeleton';

export const SponsoredLabelSkeleton: FunctionComponent = () => (
  <Skeleton width="78px" height="16px" key="title" />
);
